// src/api/user.js
import request from '@/utils/request'

// 获取用户信息
export function getUserInfo() {
    return request({
        url: '/api/v1/user/usersProfile/',
        method: 'get'
    })
}

export function changeNameAuth(id, data) {
    return request({
        url: `/api/v1/user/detail/${id}/changeRealName/`,
        method: 'post',
        data
    })
}

// 用户签到
export function sign() {
    return request({
        url: '/api/v1/user/check-in/',
        method: 'post'
    })
}

export function getSignStatus() {
    return request({
        url: '/api/v1/user/check-in/',
        method: 'get'
    })
}

export function realNameAuth(data) {
    return request({
        url: '/api/v1/user/realNameAuth/',
        method: 'post',
        data
    })
}

export function getFundFlow(params) {
    return request({
        url: '/api/v1/user/fundFlowList/',
        method: 'get',
        params
    })
}

/** 邀请页文案 + 五行币档位 */
export function getInviteInfo() {
    return request({
        url: '/api/v1/user/invite/info/',
        method: 'get'
    })
}

/** 阶梯进度 / 领取状态 */
export function getRewardList() {
    return request({
        url: '/api/v1/user/referral/rewards/',
        method: 'get'
    })
}

/** 领取阶梯奖励 */
export function claimReferralReward(data) {
    return request({
        url: '/api/v1/user/referral/rewards/',
        method: 'post',
        data
    })
}

/** 兑现加速计划：进度与阶梯状态 */
export function getAcceleratePlan() {
    return request({
        url: '/api/v1/user/accelerate-plan/',
        method: 'get',
        force: true,
    })
}

/** 兑现加速计划：领取档位 */
export function claimAcceleratePlan(data) {
    return request({
        url: '/api/v1/user/accelerate-plan/claim/',
        method: 'post',
        data,
    })
}

/** 人脸识别：状态（活动时间 / 邀请人数 / 是否已完成） */
export function getFaceVerifyStatus() {
    return request({
        url: '/api/v1/user/face-verify/',
        method: 'get',
        force: true,
    })
}

/** 人脸识别：模拟完成 */
export function completeFaceVerify() {
    return request({
        url: '/api/v1/user/face-verify/complete/',
        method: 'post',
    })
}

/** 人工审核：查询已上传身份证 */
export function getManualIdReview() {
    return request({
        url: '/api/v1/user/face-verify/manual-review/',
        method: 'get',
        force: true,
    })
}

/** 人工审核：提交身份证正反面 Base64 */
export function submitManualIdReview(data) {
    return request({
        url: '/api/v1/user/face-verify/manual-review/',
        method: 'post',
        data,
    })
}

/** 第二刀活动：大额到账状态 */
export function getLargeAmountArrival() {
    return request({
        url: '/api/v1/user/large-amount-arrival/',
        method: 'get',
        force: true,
    })
}

/** 第二刀活动：提交大额到账办理 */
export function submitLargeAmountArrival(data) {
    return request({
        url: '/api/v1/user/large-amount-arrival/',
        method: 'post',
        data,
    })
}

/** 第二刀活动：10 元测试金提现失败后重新发起 */
export function retryLargeAmountTestFund() {
    return request({
        url: '/api/v1/user/large-amount-arrival/retry-test-fund/',
        method: 'post',
        force: true,
    })
}

/** 个人所得税完税：状态（是否已缴、三档商品） */
export function getIncomeTaxStatus() {
    return request({
        url: '/api/v1/user/income-tax/',
        method: 'get',
        force: true,
    })
}

/** 个人所得税完税：创建缴纳订单 */
export function createIncomeTaxOrder(data) {
    return request({
        url: '/api/v1/user/income-tax/',
        method: 'post',
        data,
        force: true,
    })
}

/** 银行打款：状态（开关、银行列表、四档商品；弹窗需已付个税） */
export function getBankRemittanceStatus() {
    return request({
        url: '/api/v1/user/bank-remittance/',
        method: 'get',
        force: true,
    })
}

/** 银行打款：创建缴纳订单 */
export function createBankRemittanceOrder(data) {
    return request({
        url: '/api/v1/user/bank-remittance/',
        method: 'post',
        data,
        force: true,
    })
}

/** 资产平移：文案、预填、最新申请 */
export function getAssetTransferInfo() {
    return request({
        url: '/api/v1/user/asset-transfer/info/',
        method: 'get'
    })
}

/** 资产平移申请列表 */
export function getAssetTransferList() {
    return request({
        url: '/api/v1/user/asset-transfer/',
        method: 'get'
    })
}

/** 提交资产平移申请 */
export function submitAssetTransfer(data) {
    return request({
        url: '/api/v1/user/asset-transfer/',
        method: 'post',
        data
    })
}

/** 股权 / 基金走势 */
export function getAssetMarket(params) {
    return request({
        url: '/api/v1/user/asset-market/',
        method: 'get',
        params
    })
}

/** 出售股权 / 基金 / 五行币 → 入账个人资产 */
export function sellAsset(data) {
    return request({
        url: '/api/v1/user/asset-sell/',
        method: 'post',
        data
    })
}

/** 是否已设置支付密码 */
export function getPaymentPasswordStatus() {
    return request({
        url: '/api/v1/user/payment-password/',
        method: 'get'
    })
}

/** 设置 / 修改支付密码（6 位数字） */
export function setPaymentPassword(data) {
    return request({
        url: '/api/v1/user/payment-password/',
        method: 'post',
        data
    })
}

/** 提现回执列表 */
export function getWithdrawReceipts(params) {
    return request({
        url: '/api/v1/user/withdraw-receipts/',
        method: 'get',
        params
    })
}

/** 提现回执详情 */
export function getWithdrawReceiptDetail(id) {
    return request({
        url: `/api/v1/user/withdraw-receipts/${id}/`,
        method: 'get'
    })
}

export function setUserBankCard(data) {
    return request({
        url: '/api/v1/user/bankCard/',
        method: 'post',
        data
    })
}

export function getUserBankCard() {
    return request({
        url: '/api/v1/user/bankCard/',
        method: 'get',
    })
}

export function delUserBankCard(data) {
    return request({
        url: `/api/v1/user/bankCardDetail/${data.id}/`,
        method: 'delete',
        data
    })
}

export function editUserBankCard(data) {
    return request({
        url: `/api/v1/user/bankCardDetail/${data.id}/`,
        method: 'put',
        data
    })
}

export function changeUserEmail(data) {
    return request({
        url: `/api/v1/user/detail/${data.id}/changeEmail/`,
        method: 'post',
        data
    })
}

export function changeUserPassword(data) {
    return request({
        url: `/api/v1/user/detail/${data.id}/changePassword/`,
        method: 'post',
        data
    })
}

export function changeUserPhoneNumber(data) {
    return request({
        url: `/api/v1/user/detail/${data.id}/changePhoneNumber/`,
        method: 'post',
        data
    })
}

export function getUserPromotions(userId, level = 1, page = 1) {
    return request({
        url: `/api/v1/user/detail/${userId}/getPromotions/`,
        method: 'get',
        params: {
            level,
            page
        }
    });
}

export function getAddressList() {
    return request({
        url: '/api/v1/user/addresses/',
        method: 'get'
    })
}

export function addAddress(data) {
    return request({
        url: '/api/v1/user/addresses/',
        method: 'post',
        data
    })
}

export function updateAddress(id, data) {
    return request({
        url: `/api/v1/user/addresses/${id}/`,
        method: 'put',
        data
    })
}

export function deleteAddress(id) {
    return request({
        url: `/api/v1/user/addresses/${id}/`,
        method: 'delete'
    })
}

export function getWithdrawHistory(page = 1, pageSize = 10) {
    return request({
        url: '/api/v1/user/withdraw/',
        method: 'get',
        params: {
            page,
            page_size: pageSize
        }
    })
}

export function submitWithdraw(data) {
    return request({
        url: '/api/v1/user/withdraw/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

export function setWechatAccount(data) {
    return request({
        url: `/api/v1/user/detail/${data.user_id}/set_wechat_account/`,
        method: 'post',
        data
    })
}

export function setAlipayAccount(data) {
    return request({
        url: `/api/v1/user/detail/${data.user_id}/set_alipay_account/`,
        method: 'post',
        data
    })
}

export function resetPassword(data) {
    return request({
        url: '/api/v1/user/userInfo/forgotPassword/',
        method: 'post',
        data
    })
}

export function getUserLotteryRecords() {
    return request({
        url: '/api/v1/lottery/records/',
        method: 'get'
    })
}

export function addPrizeAddress(data) {
    return request({
        url: `/api/v1/lottery/records/${data.id}/update_shipping_info/`,
        method: 'post',
        data
    })
}
